<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4969 4969"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_118617344">
   <path class="fil0"
         d="M4468 2704l0 -182c-3,-6 -27,-312 -86,-479 -43,-118 -48,-143 -107,-268 -90,-191 -166,-277 -283,-422l-145 -146c-53,-49 -178,-144 -234,-179 -369,-223 -643,-297 -1107,-302 7,67 30,155 44,225 17,90 124,650 135,658 12,7 123,24 156,33 558,154 878,722 708,1282 -30,98 -70,183 -120,260 -28,44 -52,72 -81,109 -11,15 -32,35 -44,48 -157,154 -325,250 -558,291 -221,38 -462,-6 -638,-94 -178,-90 -297,-209 -398,-357 -75,-111 -135,-278 -152,-413 -4,-32 -10,-161 -13,-172 -13,-8 -830,-258 -852,-259 -30,330 -16,579 75,873 106,342 321,654 587,873 319,263 713,417 1153,431 435,13 867,-114 1210,-374 21,-15 45,-36 67,-53 13,-10 22,-18 33,-27l156 -151c37,-44 74,-86 109,-131 63,-81 130,-187 186,-301 54,-109 104,-231 133,-353 17,-69 31,-129 43,-203 6,-41 16,-196 23,-217z" />
    <path class="fil1"
          d="M298 1897l0 12c42,9 101,32 146,46l431 138c380,125 769,240 1145,366 92,31 194,63 288,92l144 46c44,13 97,29 139,44 2,-36 -48,-243 -59,-296l-367 -1769c-19,-92 -47,-202 -60,-292l-18 0c-20,12 -136,35 -171,44 -151,41 -323,108 -458,181 -216,116 -319,193 -498,349 -37,32 -71,70 -108,106 -38,36 -114,127 -149,170 -100,123 -220,319 -285,461 -22,49 -44,99 -64,150 -11,29 -44,136 -56,152z" />
  </g>
   <rect class="fil2" width="4969" height="4969" />
 </g>
</svg>
</template>

<script>
export default {
  name: "Jablotron",
};
</script>

<style scoped>
.fil2 {
  fill: none
}

.fil0 {
  fill: black
}

.fil1 {
  fill: #FBBA00
}
</style>
